import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { ActividadEconomica } from "src/app/models/ActividadEconomica";
import { ActividadEconomicaEmisor } from "src/app/models/ActividadEconomicaEmisor";
import { Ambiente } from "src/app/models/Ambiente";
import { CasillaDteRecibido } from "src/app/models/CasillaDteRecibidos/CasillaDteRecibido";
import { DatosCasilla } from "src/app/models/CasillaDteRecibidos/DatosCasilla";
import { TipoProveedorCorreo } from "src/app/models/CasillaDteRecibidos/TipoProveedorCorreo";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { EmisorFilter } from "src/app/models/Emisor/EmisorFilter";
import { PersonaAutorizada } from "src/app/models/PersonaAutorizada";
import { Sucursal } from "src/app/models/Sucursal";
import { SucursalFilter } from "src/app/models/Usuario/SucursalFilter";
import { CasillaDteRecibidoService } from "src/app/services/CasillaDteRecibido/casilla.dte.recibido.service";
import { TipoProveedorCorreoService } from "src/app/services/CasillaDteRecibido/tipo.proveedor.correo.service";
import { EmisorService } from "src/app/services/emisor.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { SessionUser } from "src/app/shared/models/sessionUser";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as FileSaver from "file-saver";
import { PersonasAutorizadasService } from "../../../services/paseronas-autorizadas.service";
import { RutHelper } from "src/app/helpers/rut.helper";

@Component({
	selector: "app-company-panel",
	templateUrl: "./company-panel.component.html",
	styleUrls: ["./company-panel.component.scss"],
})
export class CompanyPanelComponent implements OnInit {
	public loading: boolean = false;
	public currentEmisorList: Emisor[] = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
	public currentEmisorId = this.tokenStorage.getCompany();
	public currentEmisor = this.currentEmisorList.find((e) => e.emisorId == this.currentEmisorId);
	public page = new Page();
	public pageSucursal = new Page();
	public filter = new EmisorFilter();
	public filterSucursal = new SucursalFilter();
	public emisorToEdit: Emisor = new Emisor();
	public filteredEmisor: Emisor;
	public branches: Sucursal[] = [];
	public environmentType: Ambiente[] = JSON.parse(this.localStorage.getTipoAmbiente()) as Ambiente[];
	public actividadesEconomicas: ActividadEconomica[] = [];
	public personasAutorizadas: PersonaAutorizada[] = [];
	public casillasCorreo: CasillaDteRecibido[] = [];
	public branchToShow: Sucursal;
	public branchToEdit: Sucursal;
	public branchToAdd: Sucursal;
	public detailSucursalModal: any;
	private editSucursalModal: any;
	private addNewSucursalModal: any;
	private activitiesModal: any;
	public updateAuthorizedPersonForm: FormGroup;
	public addAuthorizedPersonForm: FormGroup;
	private updateAuthorizedPersonModal: any;
	private addAuthorizedPersonModal: any;
	public personToEdit: PersonaAutorizada;
	public addMailBoxForm: FormGroup;
	public updateMailBoxForm: FormGroup;
	public mailTypes: TipoProveedorCorreo[] = [];
	private addMailBoxModal: any;
	private editCompanyModal: any;
	public files: File[] = [];
	private MailBoxToEdit = new CasillaDteRecibido();
	private updateMailBoxModal: any;
	public validDate: boolean = true;
	public selected: any = { startDate: null, endDate: null };
	private superAdmin = this.tokenService.getUser().superAdmin;
	private closeActionsHandler: any;
	constructor(
		private emisorService: EmisorService,
		private tipoProveedorService: TipoProveedorCorreoService,
		private personasAutorizadasService: PersonasAutorizadasService,
		private localStorage: LocalStorageService,
		private tokenStorage: TokenStorageService,
		private ref: ChangeDetectorRef,
		private utilities: UtilitiesService,
		private casillaService: CasillaDteRecibidoService,
		private modalService: NgbModal,
		public permissions: PermissionService,
		private formBuilder: FormBuilder,
		private tokenService: TokenStorageService
	) {
		this.selected.startDate = moment().subtract(4, "days").startOf("day");
		this.selected.endDate = moment().subtract(1, "days").startOf("day");
	}
	locale = {
			startDate: this.emisorToEdit.fechaResol,
			daysOfWeek: moment.weekdaysMin(),
			monthNames: moment.monthsShort(),
			firstDay: moment.localeData().firstDayOfWeek(),
			applyLabel: "ok",
			clearLabel: "Limpiar",
			format: "DD/MM/YYYY",
		};
	toggleActions(row: any): void {
		const newState = !row.showActions;
		this.branches.forEach(r => {
			if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
			}
		});
		this.personasAutorizadas.forEach(p => {
			if (p !== row && p.showActions) {
			  p.showActions = false;
			  document.removeEventListener('click', this.closeActionsHandler);
			}
		  });
		
		row.showActions = newState;
		
		if (newState) {
			this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
			setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}
		  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}
	openEditCompanyModal(modalRef) {
		this.emisorToEdit = { ...this.filteredEmisor };
		this.editCompanyModal = this.modalService.open(modalRef, {
		  windowClass: "",
		  size: "lg",
		  centered: true,
		});
	  }

	  updateCompany(form) {
		if (form.invalid) return; 
	  
		this.loading = true;
		this.emisorToEdit.ambiente = this.emisorToEdit.ambienteEnt.ambienteId;
		this.emisorToEdit.representanteLegalRut = parseInt(this.emisorToEdit.representanteLegalRutString.substring(0, this.emisorToEdit.rutString.length - 2));
		this.emisorToEdit.representanteLegalDv = this.emisorToEdit.representanteLegalRutString.substring(this.emisorToEdit.representanteLegalRutString.length - 1);
		this.emisorService.updateEmisor(this.emisorToEdit).subscribe(
		  (res) => {
			
			this.filteredEmisor = { ...this.emisorToEdit };
			this.editCompanyModal.close();
			this.loading = false;
			this.ref.detectChanges();
			Swal.fire({
			  icon: "success",
			  title: "Empresa Actualizada",
			  html: "La empresa fue actualizada con éxito",
			});
			this.tokenService.updateAmbientOfCompany(this.emisorToEdit.emisorId, this.emisorToEdit.ambiente);
		  },
		  (err) => {
			this.loading = false;
			Swal.fire({
			  icon: "error",
			  title: "Error al Actualizar",
			  text: "No fue posible actualizar la empresa: " + this.utilities.setErrorMessageFromArray(err.error),
			});
		  }
		);
	  }
	  
	detectChangeReferenceDateEdit(event) {
		this.validDate = true;
		if (event.startDate != null && event.endDate != null) {
			this.emisorToEdit.fechaResol = moment(event.startDate).toDate();
		} else {
			if (event.target && event.target.value) {
				this.validDate = moment(event.target.value, "DD/MM/YYYY", true).isValid();
				if (this.validDate) {
					let newDate = moment(event.target.value, "DD-MM-YYYY").format("L");
					if (moment(this.emisorToEdit.fechaResol).format("L") != newDate) {
						let dateToSave = moment(event.target.value, "DD-MM-YYYY");
						this.emisorToEdit.fechaResol = dateToSave.toDate();
					}
				}
			}
		}
	}

	ngOnInit(): void {
		this.setPage();
		this.setPageSucursal({ offset: 0 });
		this.getEconomicActivities();
		this.getAuthorizedPersons();
		this.getMailBoxes();
		this.getMailtypes();
		this.setPersonsForms();
	}

	setPage() {
		this.loading = true;
		this.filter.rut = this.currentEmisor.rutString;
		this.filter.activo = 1;
		this.page.pageNumber = 0;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		this.emisorService
			.getDataByPage(this.filter, localPage, this.tokenStorage.getUser().id)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as Emisor[];
					this.ref.detectChanges();
					this.filteredEmisor = elements.find((e) => e.emisorId == this.currentEmisorId);

					this.filteredEmisor.ambienteEnt = this.environmentType[this.filteredEmisor.ambiente];
					this.filteredEmisor.ambiente = this.filteredEmisor.ambienteEnt.ambienteId;
					this.filteredEmisor.nombreAmbiente = this.filteredEmisor.ambienteEnt.nombre;
					this.loading = false;

					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					Swal.fire({
						icon: "error",
						title: "Error en la solicitud",
						text: " error.error.message",
					});
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	setPageSucursal(pageInfo) {
		this.loading = true;
		this.pageSucursal.pageNumber = pageInfo.offset;
		this.pageSucursal.pageNumber += 1;
		this.filterSucursal.emisorId = this.currentEmisorId;
		this.filterSucursal.activo = 1;
		this.emisorService
			.getSucursalDataByPage(this.filterSucursal, this.pageSucursal)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as Sucursal[];
					this.ref.detectChanges();
					this.setPagefromSucursalResponse(this.pageSucursal, pagedData);
					this.branches = [...elements];
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					Swal.fire({
						icon: "error",
						title: "Error en la solicitud",
						text: this.utilities.setErrorMessageFromArray(error.error),
					});
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	getEconomicActivities() {
		this.loading = true;
		this.emisorService.getEconomicActivitiesByEmisor(this.currentEmisorId).subscribe(
			(result) => {
				this.loading = false;
				this.actividadesEconomicas = result.data;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Actividades Económicas No Encontradas",
					text: "Error al buscar actividades económicas del emisor." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	setPagefromSucursalResponse(currentPage: Page, data: PagedResponse<Sucursal>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	getAuthorizedPersons() {
		this.loading = true;
		this.personasAutorizadasService.getAuthorizedPersonsByEmisor(this.currentEmisorId).subscribe(
			(result) => {
				this.loading = false;
				this.personasAutorizadas = result.data;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Personas Autorizadas para Cesion no encontradas",
					text: "Error al buscar personas autorizadas para cesión del emisor" + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	getMailBoxes() {
		this.loading = false;
		this.casillaService.getCasillasDteRecibidoByEmisor(this.currentEmisorId).subscribe(
			(res) => {
				this.casillasCorreo = res.data.filter((casilla) => casilla.activo);
				this.loading = false;
				this.ref.detectChanges();
				// if (res.data.length == 0) {
				//    Swal.fire({
				//       icon: "info",
				//       title: "Casillas de Correo Vacias",
				//       text: res.message,
				//    });
				// }
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Casillas de Correo No Encontradas",
					text: "Error al buscar casillas dte recibidos del emisor " + this.currentEmisor.razonSocial,
				});
			}
		);
	}

	detailBranchOfficeModal(modalRef, row: Sucursal) {
		this.loading = true;
		this.branchToShow = row;
		this.loading = false;
		this.ref.detectChanges();
		this.detailSucursalModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	editBranchOfficeModal(modalRef, row: Sucursal) {
		this.loading = true;
		this.branchToEdit = new Sucursal();
		this.branchToEdit.emisorId = row.emisorId;
		this.branchToEdit.sucursalId = row.sucursalId;
		this.branchToEdit.nombre = row.nombre;
		this.branchToEdit.direccion = row.direccion;
		this.loading = false;
		this.ref.detectChanges();
		this.editSucursalModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	editBranchOffice(editForm) {
		this.loading = true;
		this.emisorService.updateBranchOffice(this.branchToEdit).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Sucursal Actualizada",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + "La sucursal " + this.branchToEdit.nombre + " fue actualizada correctamente" + "</p></div>",
				});
				this.setPageSucursal({ offset: 0 });
				this.editSucursalModal.close();
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Actualizar Sucursal",
					text: this.utilities.setErrorMessageFromArray(err.error),
				});
			}
		);
	}

	activateBranchOffice(row: Sucursal) {
		this.loading = true;
		this.emisorService.activateBranchOffice(row.sucursalId).subscribe(
			(res) => {
				if (res.data) {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "success",
						title: "Sucursal Activada",
						showCloseButton: true,
						html: "<div style='text-align:center;'><p>" + "Sucursal " + row.nombre + " Activado" + "</p></div>",
					});
					this.setPageSucursal({ offset: 0 });
				}
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Activar",
					text: "No fue posible activar la sucursal " + row.nombre,
				});
			}
		);
	}

	deactivateBranchOffice(row: Sucursal) {
		this.loading = true;
		this.emisorService.deactivateBranchOffice(row.sucursalId).subscribe(
			(res) => {
				if (res.data) {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "success",
						title: "Sucursal Desactivada",
						showCloseButton: true,
						html: "<div style='text-align:center;'><p>" + "Sucursal " + row.nombre + " Desactivada" + "</p></div>",
					});
					this.setPageSucursal({ offset: 0 });
				}
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Desactivar",
					text: "No fue posible desactivar la sucursal " + row.nombre + this.utilities.setErrorMessageFromArray(err.error),
				});
			}
		);
	}
	addBranchOfficeModal(modalRef) {
		this.loading = true;
		this.branchToAdd = new Sucursal();
		this.branchToAdd.emisorId = this.currentEmisorId;
		this.loading = false;
		this.ref.detectChanges();
		this.addNewSucursalModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}
	addBranchOffice(modalRef) {
		this.loading = true;
		this.emisorService.addBranchOffice(this.branchToAdd).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				if (res.data) {
					Swal.fire({
						icon: "success",
						title: "Sucursal Agregada",
						showCloseButton: true,
						html: "<div style='text-align:center;'><p>" + "La Sucursal " + this.branchToAdd.nombre + " fue agregada" + "</p></div>",
					});
					this.filterSucursal.emisorId = this.currentEmisorId;
					this.filterSucursal.activo = null;
					this.setPageSucursal({ offset: 0 });
					this.addNewSucursalModal.close();
				} else {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "info",
						title: "Nombre de la Sucursal Existente",
						text: res.message,
					});
				}
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Agregar Sucursal",
					text: this.utilities.setErrorMessageFromArray(err.error),
				});
			}
		);
	}
	//ECONOMIC ACTIVITIES METHODS
	openActivitiesModal(modalRef) {
		let activities = [...this.actividadesEconomicas];
		this.currentEmisor.actividadesEconomicas = activities;
		this.activitiesModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	closeEconomicActivitiesModal() {
		this.activitiesModal.close();
	}

	updateEconomicActivitiesRequest(event: ActividadEconomicaEmisor[]) {
		this.loading = true;
		this.emisorService.toAssignEconomicActivity(event).subscribe(
			(result) => {
				this.loading = false;
				this.getEconomicActivities();
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Actividades Económicas Actualizadas",
					text: "Las actividades económicas fueron actualizadas exitosamente",
				});
				this.closeEconomicActivitiesModal();
			},
			(error) => {
				this.loading = false;
				let errorText = error.error.message;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error Al actualizar Actividades Económicas",
					text: "No ha sido posible actualizar las actividades económicas del emisor." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	//AUTHORIZED PERSONS METHODS
	setPersonsForms() {
		this.addAuthorizedPersonForm = this.formBuilder.group({
			rutString: [, [Validators.required, VerificacionRutValidator]],
			nombre: [, Validators.required],
			correo: [, [Validators.required, SingleEmailValidator]],
		});
		this.updateAuthorizedPersonForm = this.formBuilder.group({
			rutString: ["", [Validators.required, VerificacionRutValidator]],
			nombre: ["", Validators.required],
			correo: ["", [Validators.required, SingleEmailValidator]],
		});
	}
	closeUpdateAuthorizedPersonModal() {
		this.updateAuthorizedPersonModal.close();
	}
	updatePerson() {
		this.loading = false;
		if (this.updateAuthorizedPersonForm.valid) {
			var rut = this.updateAuthorizedPersonForm.get("rutString").value;
			const { rut: rutNumber, dv } = RutHelper.parse(rut);
			this.personToEdit.rut = rutNumber;
			this.personToEdit.dv = dv;
			this.personToEdit.activo = true;
			this.personToEdit.correo = this.updateAuthorizedPersonForm.get("correo").value;
			this.personToEdit.nombre = this.updateAuthorizedPersonForm.get("nombre").value;
			this.personToEdit.emisorId = this.currentEmisorId;
			this.personasAutorizadasService
				.updateAuthorizedPersons(this.personToEdit)
				.subscribe(
					(res) => {
						Swal.fire({
							icon: "success",
							title: "Persona Autorizada Actualizada",
							text: "Se ha actualizado exitosamente a la persona autorizada " + this.personToEdit.nombre,
						});
						this.getAuthorizedPersons();
						this.loading = false;
						this.ref.detectChanges();
						this.closeUpdateAuthorizedPersonModal();
					},
					(err) => {
						this.loading = false;
						this.ref.detectChanges();
						if (err.error.data) {
							Swal.fire({
								icon: "info",
								title: "Persona Autorizada Existente",
								text: "Ya existe una persona autorizada con el rut " + this.personToEdit.rutFormateado,
							});
						} else {
							Swal.fire({
								icon: "error",
								title: "Error al Actualizar Persona Autorizada",
								text: "No se ha podido actualizar a la persona autorizada " + this.personToEdit.nombre + ", intente nuevamente",
							});
						}
					}
				)
				.add(() => {
					this.loading = false;
				});
		}
	}
	openUpdateAuthorizedPersonModal(modalRef, item) {
		this.loading = false;
		this.personToEdit = new PersonaAutorizada();
		this.personToEdit = item;
		this.setAutorizedPersonForm(item);
		this.updateAuthorizedPersonModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}
	setAutorizedPersonForm(authorizedPerson) {
		this.updateAuthorizedPersonForm.patchValue(authorizedPerson);
		this.updateAuthorizedPersonForm.get("rutString").patchValue(authorizedPerson.rutFormateado);
		this.updateAuthorizedPersonForm.get("nombre").patchValue(authorizedPerson.nombre);
		this.updateAuthorizedPersonForm.get("correo").patchValue(authorizedPerson.correo);
	}

	deleteAuthorizedPerson(item) {
		this.loading = true;
		this.personasAutorizadasService
			.deleteAuthorizedPersons(item)
			.subscribe(
				(res) => {
					Swal.fire({
						icon: "success",
						title: "Persona Autorizada Eliminada",
						text: "Se ha eliminado exitosamente a la persona autorizada " + item.nombre,
					});
					this.getAuthorizedPersons();
					this.loading = false;
					this.ref.detectChanges();
				},
				(err) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "info",
						title: "Error al Eliminar",
						text: "No fue podible eliminar a la persona autorizada " + item.nombre,
					});
				}
			)
			.add(() => {
				this.loading = false;
			});
	}

	openAddAuthorizedPersonModal(modalRef) {
		this.addAuthorizedPersonModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}
	closeAddAuthorizedPersonModal() {
		this.addAuthorizedPersonModal.close();
	}

	addPerson() {
		if (this.addAuthorizedPersonForm.valid) {
			this.loading = true;
			var authorizedPerson = new PersonaAutorizada();
			var rut = this.addAuthorizedPersonForm.get("rutString").value;
			const { rut: rutNumber, dv } = RutHelper.parse(rut);
			authorizedPerson.rut = rutNumber;
			authorizedPerson.dv = dv;
			authorizedPerson.activo = true;
			authorizedPerson.correo = this.addAuthorizedPersonForm.get("correo").value;
			authorizedPerson.nombre = this.addAuthorizedPersonForm.get("nombre").value;
			authorizedPerson.emisorId = this.currentEmisorId;
			this.personasAutorizadasService
				.toAssignAuthorizedPersons(authorizedPerson)
				.subscribe(
					(res) => {
						this.loading = false;
						Swal.fire({
							icon: "success",
							title: "Persona Autorizada Agregada",
							text: "Se ha agregado exitosamente a la persona autorizada " + authorizedPerson.nombre,
						});
						this.getAuthorizedPersons();
						this.ref.detectChanges();
						this.closeAddAuthorizedPersonModal();
					},
					(err) => {
						this.loading = false;
						this.ref.detectChanges();
						if (err.error.data) {
							Swal.fire({
								icon: "info",
								title: "Persona Autorizada Existente",
								text: "Ya existe una persona autorizada con el rut " + authorizedPerson.rut + "-" + authorizedPerson.dv,
							});
						} else {
							Swal.fire({
								icon: "error",
								title: "Error al Agregar Persona Autorizada",
								text: "No se ha podido agregar a la persona autorizada " + authorizedPerson.nombre + ", intente nuevamente",
							});
						}
					}
				)
				.add(() => {
					this.loading = false;
				});
		}
	}

	//MAILBOXES METHODS
	getMailtypes() {
		this.loading = true;
		this.tipoProveedorService.mailTypes().subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				this.mailTypes = res.data;
				this.localStorage.saveTipoProveedorCorreo(res.data);
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Tipos de Proveedor Correo",
					text: "Error al obtener lista, " + err.error.message,
				});
			}
		);
	}
	downloadTemplate() {
		this.loading = true;
		this.casillaService
			.downloadTemplate()
			.subscribe(
				(res) => {
					this.loading = false;
					this.ref.detectChanges();
					this.loading = true;
					if (res.data.length == 0) {
						Swal.fire({
							icon: "info",
							title: "Descarga de Templates",
							text: "Sin ejemplos de casilla de correos",
						});
					} else if (res.data.length > 0) {
						res.data.forEach((template) => {
							let b64Response = template.formato;
							const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/json");
							FileSaver.saveAs(blobXml, template.nombre + ".json");
							this.loading = false;
						});
					}
				},
				(err) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "error",
						title: "Descarga de Template Fallida",
						text: "Error al descargar template, " + err.error.message,
					});
				}
			)
			.add(() => {
				this.loading = false;
			});
	}
	openAddMailBoxModal(modalRef) {
		this.loading = false;
		this.setMailboxesForms();
		this.cleanFiles();
		this.addMailBoxModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	openUpdateMailBoxModal(modalRef, row: CasillaDteRecibido) {
		this.cleanFiles();
		this.MailBoxToEdit = new CasillaDteRecibido();
		this.MailBoxToEdit = row;
		this.setMailBoxForm(row);
		this.updateMailBoxModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}
	setMailBoxForm(MailBox) {
		this.updateMailBoxForm.patchValue(MailBox);
		this.updateMailBoxForm.get("correo").patchValue(MailBox.correo);
		this.updateMailBoxForm.get("tipo").patchValue(this.mailTypes.filter((mt) => mt.tipoProveedorCorreoId == MailBox.tipoProveedorCorreoId)[0]);
	}
	closeAddMailBoxModal() {
		this.addMailBoxModal.close();
	}
	cleanFiles() {
		this.files = [];
	}
	setMailboxesForms() {
		this.addMailBoxForm = this.formBuilder.group({
			correo: ["", [Validators.required, SingleEmailValidator]],
			tipo: [this.mailTypes[0], [Validators.required]],
			configFile: [[Validators.required]],
		});
		this.updateMailBoxForm = this.formBuilder.group({
			correo: ["", [Validators.required, SingleEmailValidator]],
			tipo: [this.mailTypes[0], [Validators.required]],
			configFile: [[Validators.required]],
		});
	}

	addMailBoxRequest() {
		if (this.addMailBoxForm.valid) {
			var MailBox = new CasillaDteRecibido();
			MailBox.activo = true;
			MailBox.correo = this.addMailBoxForm.get("correo").value;
			MailBox.tipoProveedorCorreoId = (this.addMailBoxForm.get("tipo").value as TipoProveedorCorreo).tipoProveedorCorreoId;
			MailBox.emisorId = this.currentEmisorId;
			MailBox.usuarioId = (this.tokenService.getUser() as SessionUser).id;
			MailBox.datosCasilla = new DatosCasilla();
			let reader = new FileReader();
			if (this.files[0] != null) {
				reader.readAsText(this.files[0]);
				reader.onload = (e) => {
					try {
						let file = JSON.parse(reader.result as string);
						if (file) {
							MailBox.datosCasilla.serviceUrl = file.ServiceUrl;
							MailBox.datosCasilla.authenticationType = file.AuthenticationType;
							MailBox.datosCasilla.inputHost = file.InputHost;
							MailBox.datosCasilla.inputPort = file.InputPort;
							MailBox.datosCasilla.inputSSL = file.InputSSL;
							MailBox.datosCasilla.user = file.User;
							MailBox.datosCasilla.password = file.Password;
							MailBox.datosCasilla.clientId = file.ClientId;
							MailBox.datosCasilla.clientSecrets = file.ClientSecrets;
							MailBox.datosCasilla.credentialFilePath = file.CredentialFilePath;
							this.loading = true;
							this.casillaService
								.add(MailBox)
								.subscribe(
									(res) => {
										Swal.fire({
											icon: "success",
											title: "Casilla de Correo Agregada",
											text: "Se ha agregado exitosamente la casilla dte recibido " + MailBox.correo,
										});
										this.loading = false;
										this.ref.detectChanges();
										this.getMailBoxes();
										this.closeAddMailBoxModal();
									},
									(err) => {
										this.loading = false;
										this.ref.detectChanges();
										if (err.error.data) {
											Swal.fire({
												icon: "info",
												title: "Casilla de Correo Existente",
												text: "Ya existe la casilla dte recibido " + MailBox.correo,
											});
										} else {
											Swal.fire({
												icon: "error",
												title: "Error al Agregar Casilla de Correo",
												text: "No se ha podido agregar la casilla dte recibido  " + MailBox.correo + ", intente nuevamente",
											});
										}
									}
								)
								.add(() => {
									this.loading = false;
								});
						}
					} catch (error) {
						return;
					}
				};
			} else {
				Swal.fire({
					icon: "info",
					title: "Archivo de Configuración Vacio",
					text: "Seleccione un archivo de configuración válido",
				});
			}
		}
	}

	onSelect(event) {
		if (event.rejectedFiles[0] || this.getName(event) != "json") {
			Swal.fire({
				icon: "error",
				title: "Error de Archivo",
				text: "El archivo ingresado no es de formato CSV, favor agregar un archivo con el formato correcto. Razón: " + event.rejectedFiles[0].reason == "size" ? "Tamaño" : "Tipo de archivo",
			});
		}

		this.files.push(...event.addedFiles);
		if (this.files.length > 1) {
			this.files.shift();
		}
		this.addMailBoxForm.patchValue(this.files[0]);
		this.updateMailBoxForm.patchValue(this.files[0]);
	}
	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
	}
	getName(event): string {
		if (event.addedFiles) {
			return event.addedFiles[0].name.split(".").pop();
		} else if (event.rejectedFiles) {
			return event.rejectedFiles[0].name.split(".").pop();
		} else {
			return "";
		}
	}

	closeUpdateMailBoxModal() {
		this.updateMailBoxModal.close();
	}
}
